export var InputBorderStyle = /*#__PURE__*/ function(InputBorderStyle) {
    InputBorderStyle[InputBorderStyle["None"] = 0] = "None";
    InputBorderStyle[InputBorderStyle["AllSides"] = 1] = "AllSides";
    InputBorderStyle[InputBorderStyle["Bottom"] = 2] = "Bottom";
    return InputBorderStyle;
}({});
export var SubmitButtonStyle = /*#__PURE__*/ function(SubmitButtonStyle) {
    SubmitButtonStyle[SubmitButtonStyle["Rectangle"] = 0] = "Rectangle";
    SubmitButtonStyle[SubmitButtonStyle["RectangleRoundedCorners"] = 1] = "RectangleRoundedCorners";
    SubmitButtonStyle[SubmitButtonStyle["RectangleFilled"] = 2] = "RectangleFilled";
    SubmitButtonStyle[SubmitButtonStyle["RectangleRoundedCornersFilled"] = 3] = "RectangleRoundedCornersFilled";
    SubmitButtonStyle[SubmitButtonStyle["Text"] = 4] = "Text";
    return SubmitButtonStyle;
}({});

//# sourceMappingURL=style-params.js.map